import type { WorkflowListItemApi, WorkflowStageApi } from '@/hooks/useWorkflowsData';

/**
 * Mock workflows data for demo mode
 */
export const mockWorkflows: WorkflowListItemApi[] = [
  {
    id: 1,
    disputeTypeId: 1,
    disputeTypeName: 'Billing Error',
    name: 'Billing Error Resolution Workflow',
    description: 'Standard workflow for billing error disputes',
    status: 'active',
    createdByUserId: 1,
    createdByUserName: 'Admin User',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    stageCount: 3,
    transitionCount: 2,
  },
];

export const mockStages: WorkflowStageApi[] = [
  {
    id: 1,
    workflowId: 1,
    name: 'Initial Review & Categorization',
    description: 'Dispute received and automatically categorized',
    sortOrder: 1,
    color: null,
    icon: null,
    properties: null,
    notifications: null,
    requiredFields: null,
    allowedActions: null,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 2,
    workflowId: 1,
    name: 'Investigation & Evidence Gathering',
    description: 'Collecting relevant documents and customer communications',
    sortOrder: 2,
    color: null,
    icon: null,
    properties: null,
    notifications: null,
    requiredFields: null,
    allowedActions: null,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 3,
    workflowId: 1,
    name: 'Final Resolution Notice',
    description: 'Resolution approved and customer notified',
    sortOrder: 3,
    color: null,
    icon: null,
    properties: null,
    notifications: null,
    requiredFields: null,
    allowedActions: null,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
];
